import React, { useContext } from 'react';
import * as Scroll from 'react-scroll';
import styled from 'styled-components';

// Components
import EventAttendees from './EventAttendees';
import FeaturedProperties from './FeaturedProperties';
import MyEventSchedule from './MyEventSchedule';
import EventExhibitors from '../../../_organisms/EventExhibitors'; // TODO: Move this into same directory once we're sure nobody's actively working on it
import ErrorHandler from '../../../_molecules/ErrorHandler';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import SectionHeader from '../../../_molecules/SectionHeader';
import {
    ButtonPrimaryLarge,
    DivWithShadowAlternate,
    H3,
    LabelSmall,
    SectionWrapperInner,
    SectionWrapperOuter,
} from '@styled';

// Helpers
import { EventDetailProvider } from './EventDetailProvider';
import { getDateRangeTextLong } from '@general/dates';
import useDocumentTitle from '@hooks/useDocumentTitle';
import TrackPageView from '@tracking/TrackPageView';

const { scroller } = Scroll;

const EventDetailHeader = styled.div`
    margin-bottom: 64px;
`;

const HeroImage = styled.img`
    height: 342px;
    max-width: 100%;
    object-fit: cover;
    width: 100%;
`;

const TabPanelContainer = styled.div`
    margin-bottom: 46px;
`;

const EventDetailPage = () => {
    const { event } = useContext(EventDetailProvider);
    const { title, event_code: eventCode, meeting_start_time: startDate, meeting_end_time: endDate, image } = event;
    useDocumentTitle(title);

    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <EventDetailHeader>
                            <SectionHeader title="My ICSC Events" />

                            <HeroImage className="mb-3" src={image || '/assets/images/pattern-white.svg'} />

                            <div className="mb-1.5rem">
                                <SectionBreadcrumbs>
                                    <SectionBreadcrumb route="/my-icsc/events">Events</SectionBreadcrumb>
                                    <SectionBreadcrumb isActive>{title}</SectionBreadcrumb>
                                </SectionBreadcrumbs>
                            </div>

                            <H3 className="mb-1.25rem">{title}</H3>

                            <div className="mb-3rem">
                                <LabelSmall>{getDateRangeTextLong(startDate, endDate)}</LabelSmall>
                            </div>

                            <DivWithShadowAlternate className="d-block d-md-flex pt-1.25rem px-1.5rem">
                                <ButtonPrimaryLarge
                                    className="mb-1.25rem mr-1rem w-100"
                                    onClick={() => {
                                        scroller.scrollTo('my-event-schedule', {
                                            smooth: true,
                                        });
                                    }}
                                >
                                    Build Out Your Agenda
                                </ButtonPrimaryLarge>

                                <ButtonPrimaryLarge
                                    className="mb-1.25rem mr-1rem w-100"
                                    onClick={() => {
                                        scroller.scrollTo('event-attendees', {
                                            smooth: true,
                                        });
                                    }}
                                >
                                    Connect With Attendees
                                </ButtonPrimaryLarge>

                                <ButtonPrimaryLarge
                                    className="mb-1.25rem w-100"
                                    onClick={() => {
                                        scroller.scrollTo('featured-properties', {
                                            smooth: true,
                                        });
                                    }}
                                >
                                    Explore Featured Properties
                                </ButtonPrimaryLarge>
                            </DivWithShadowAlternate>
                        </EventDetailHeader>

                        <TabPanelContainer id="my-event-schedule">
                            <MyEventSchedule />
                        </TabPanelContainer>

                        <TabPanelContainer id="event-attendees">
                            <EventAttendees event={event} />
                        </TabPanelContainer>

                        <TabPanelContainer id="featured-properties">
                            <FeaturedProperties eventCode={eventCode} />
                        </TabPanelContainer>

                        <div id="event-exhibitors">
                            <EventExhibitors eventCode={eventCode} />
                        </div>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default EventDetailPage;
